export const IMAGE_OPTIONS = {
  MAP: 'map',
  GRAPHIC: 'graphic',
};
